import { render, staticRenderFns } from "./ManageLogo.vue?vue&type=template&id=bfa5fc92&"
import script from "./ManageLogo.vue?vue&type=script&lang=js&"
export * from "./ManageLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports